// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/player." + (chunkId === 992 ? "tailwindcss" : chunkId) + "." + {"86":"955fbec2","640":"8306f812","672":"4ad32a28","970":"e797989c","992":"b67572ec"}[chunkId] + ".css";
};